import { Fragment } from 'react';
import { getRandomUid } from 'utilities/uuid.service';
import Select from 'react-select';

function SelectBoxV2({ children, labelProps = {}, selectProps = {}, fieldErrors = {} }) {
  const { label = 'Select label', ...rest } = labelProps;
  const { id, className = '', ...props } = selectProps;

  const selectBoxID = id ?? getRandomUid();

  let selectBoxClasses = '';
  const { errorMessage = '' } = fieldErrors;

  if (errorMessage) {
    selectBoxClasses = `${className} border border-danger`;
  }

  return (
    <Fragment>
      <label htmlFor={selectBoxID} {...rest}>
        {label}
      </label>
      <Select
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
        }}
        id={selectBoxID}
        className={selectBoxClasses}
        {...props}
      />
    </Fragment>
  );
}

export default SelectBoxV2;
